/**
 * swisspostsolutionscms - JSON API
 * This is a JSON API compliant implementation
 *
 * The version of the OpenAPI document: Versioning not supported
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Options } from './options';
import { TeaserLink } from './teaserLink';
import { PublicationDate } from './publicationDate';
import { URLAlias } from './uRLAlias';


/**
 * Entity attributes
 */
export interface NodeBlogDataAttributes { 
    field_newsletter?: NodeBlogDataAttributes.FieldNewsletterEnum;
    /**
     * The meta tags for the entity.
     */
    metatag: object;
    /**
     * The time that the node was created.
     */
    created?: string;
    field_location?: NodeBlogDataAttributes.FieldLocationEnum;
    field_category_blog?: Array<NodeBlogDataAttributes.FieldCategoryBlogEnum>;
    title: string;
    field_teaser_headline_page: string;
    field_industry_blog?: NodeBlogDataAttributes.FieldIndustryBlogEnum;
    drupal_internal__nid: number;
    path: URLAlias;
    langcode?: string;
    field_breadcrumb?: NodeBlogDataAttributes.FieldBreadcrumbEnum;
    field_publication_date?: PublicationDate;
    field_teaser_link_page: TeaserLink;
    field_hreflang_url?: string;
    field_teaser_subheadline_page: string;
    /**
     * The moderation state of this piece of content.
     */
    moderation_state?: string;
    breadcrumbs: Array<Options>;
    status?: boolean;
    /**
     * The time that the node was last edited.
     */
    changed?: string;
}
export namespace NodeBlogDataAttributes {
    export type FieldNewsletterEnum = 'true' | 'false';
    export const FieldNewsletterEnum = {
        True: 'true' as FieldNewsletterEnum,
        False: 'false' as FieldNewsletterEnum
    };
    export type FieldLocationEnum = 'eu' | 'us';
    export const FieldLocationEnum = {
        Eu: 'eu' as FieldLocationEnum,
        Us: 'us' as FieldLocationEnum
    };
    export type FieldCategoryBlogEnum = 'AI_&_Tec' | 'About_SPS' | 'Business_efficiency' | 'Customer_Experience' | 'Employee_Experience' | 'Smart_workplaces';
    export const FieldCategoryBlogEnum = {
        AiTec: 'AI_&_Tec' as FieldCategoryBlogEnum,
        AboutSps: 'About_SPS' as FieldCategoryBlogEnum,
        BusinessEfficiency: 'Business_efficiency' as FieldCategoryBlogEnum,
        CustomerExperience: 'Customer_Experience' as FieldCategoryBlogEnum,
        EmployeeExperience: 'Employee_Experience' as FieldCategoryBlogEnum,
        SmartWorkplaces: 'Smart_workplaces' as FieldCategoryBlogEnum
    };
    export type FieldIndustryBlogEnum = 'Banking' | 'Insurance' | 'Healthcare';
    export const FieldIndustryBlogEnum = {
        Banking: 'Banking' as FieldIndustryBlogEnum,
        Insurance: 'Insurance' as FieldIndustryBlogEnum,
        Healthcare: 'Healthcare' as FieldIndustryBlogEnum
    };
    export type FieldBreadcrumbEnum = 'yes' | 'no';
    export const FieldBreadcrumbEnum = {
        Yes: 'yes' as FieldBreadcrumbEnum,
        No: 'no' as FieldBreadcrumbEnum
    };
}


